import { NETWORK } from "@mucki/shared";

/**
 * Gates the connection behind a display name. The server sanitizes and bounds
 * whatever arrives — this is convenience, not validation.
 */
export function askForName(parent: HTMLElement = document.body): Promise<string> {
  const overlay = document.createElement("div");
  overlay.className = "name-entry";

  const title = document.createElement("h1");
  title.textContent = "Mucki the Cat";

  const label = document.createElement("label");
  label.textContent = "Name your cat";

  const input = document.createElement("input");
  input.type = "text";
  input.maxLength = NETWORK.playerName.maxLength;
  input.placeholder = "Mucki";
  input.autocomplete = "off";

  const button = document.createElement("button");
  button.type = "button";
  button.textContent = "Enter the zone";

  overlay.append(title, label, input, button);
  parent.appendChild(overlay);
  input.focus();

  return new Promise((resolve) => {
    const submit = () => {
      overlay.remove();
      resolve(input.value);
    };
    button.addEventListener("click", submit);
    input.addEventListener("keydown", (event) => {
      if (event.key === "Enter") submit();
    });
  });
}
